import request from "@/utils/request";
import axios from 'axios';

const CancelToken = axios.CancelToken;
export let myCancel;

export function getMarketList(params) {
  return request.post('/base/market/dataGrid', params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateMarketName(params) {
  return request.put(`/base/market/updateName`, params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function enableMarket(marketId) {
  return request.put(`/base/market/enable/${marketId}`)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function disableMarket(marketId) {
  return request.put(`/base/market/disable/${marketId}`)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function deleteMarket(marketId) {
    return request.delete(`/base/market/deleteMarket/${marketId}`)
        .then((res) => {
            return Promise.resolve(res);
        });
}


//获取店铺授权验证链接
export function getMarketAuthUrl(params) {
    if (typeof myCancel === 'function') {
        // 取消请求
        myCancel()
    }
  return request.post(`/base/market/authUrl`, params,{
      cancelToken: new CancelToken(function executor (c) {
          myCancel = c
      })
  })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

//广告授权地址-新
export function getAdsBatchAuthUrl(params) {
    if (typeof myCancel === 'function') {
        // 取消请求
        myCancel()
    }
    return request.post(`/base/market/adsBatchAuthUrl`,params,{
        cancelToken: new CancelToken(function executor (c) {
            myCancel = c
        })
    })
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getAdsAuthUrl(marketId) {
  return request.get(`/base/market/adsAuthUrl?marketId=${marketId}`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 参数形式 params: ?a=1&b=2
export function adsApiAuth(params) {
  return request.get(`/base/market/adsApiAuth${params}`)
    .then((res) => {
      return Promise.resolve(res);
    });
}

// 参数形式 params: ?a=1&b=2
export function marketApiAuth(params) {
  return request.post(`/base/market/apiAuth`,params)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

// 标签

export function getListingSetting(params) {
  return request.get(`/operation/listingSetting`, { params })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function addListingSetting(params) {
  return request.post(`/operation/listingSetting`, params)
    .then((res) => {
      return Promise.resolve(res);
    });
}

export function deleteListingSetting(id) {
  return request.delete(`/operation/listingSetting?id=${id}`)
    .then((res) => {
      return Promise.resolve(res);
    });
}

// 汇率
export function getExchangeRatePage(monthDate) {
  return request.post(`/base/exchangeRate/queryData?monthDate=${monthDate}`)
    .then((res) => {
      return Promise.resolve(res.data);
    });
}

export function updateCustomRate(params) {
  return request.post(`/base/exchangeRate/upCustomRate`, params);
}
/* 标签管理 */

// 添加标签
export function tagAdd(params) {
  return request.post(`/crm/tag/add`, params);
}
// 编辑标签
export function tagUpdate(params) {
  return request.put(`/crm/tag/update`, params)
    .then((res) => {
      return Promise.resolve(res)
    })
}
// 删除标签
export function deleteTag(id) {
  return request.delete(`/crm/tag/delete?id=${id}`)
    .then((res) => {
      return Promise.resolve(res)
    })
}
// 停用/启用标签
export function stateSwitchTag(params) {
  return request.put(`/crm/tag/stateSwitch`, params)
    .then((res) => {
      return Promise.resolve(res)
    })
}
// 批量删除标签
export function deleteBatchTag(ids) {
  return request.delete(`/crm/tag/deleteBatch`, { data: ids })
    .then((res) => {
      return Promise.resolve(res)
    })
}

// 批量启用/停用标签
export function stateSwitchBatchTag(params) {
  return request.put(`/crm/tag/stateSwitchBatch`, params)
    .then((res) => {
      return Promise.resolve(res)
    })
}

// 添加标签分类
export function tagCategoryAdd(params) {
  return request.post(`/crm/tagCategory/add`, params)
    .then((res) => {
      return Promise.resolve(res)
    })
}
// 修改标签分类 未联调
export function tagCategoryUpdate(params) {
  return request.put(`/crm/tagCategory/update`, params)
    .then((res) => {
      return Promise.resolve(res)
    })
}
// 删除标签分类
export function tagCategoryDelete(id) {
  return request.delete(`/crm/tagCategory/delete?id=${id}`)
    .then((res) => {
      return Promise.resolve(res)
    })
}
// 查询标签分类/标签树
export function getTagTreeList() {
  return request.get(`/crm/tagCategory/get`)
    .then((res) => {
      return Promise.resolve(res);
    })
}
// 标签列表
export function getTagList(params) {
  return request.post(`/crm/tag/tagList`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}
// 操作日志
export function getLogList(params) {
  return request.post(`/crm/tag/getLog`, params)
    .then((res) => {
      return Promise.resolve(res.data)
    })
}
// 导入标签
export function importTag(attachmentId) {
  return request.post(`/crm/tag/importTag?attachmentId=${attachmentId}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}
// 导入标签分类
export function importTagCategory(attachmentId) {
  return request.post(`/crm/tagCategory/importTagCategory?attachmentId=${attachmentId}`)
    .then((res) => {
      return Promise.resolve(res);
    })
}
// 前4级标签分类树
export function fourToTreeList() {
  return request.get(`/crm/tagCategory/fourToTree`)
    .then((res) => {
      return Promise.resolve(res);
    })
}
// 标签详情
export function tagDetail(id){
  return request.get(`/crm/tag/tagDetail?id=${id}`)
  .then((res)=>{
    return Promise.resolve(res);
  })
}

// 获取任务列表
export function getTaskList() {
    return request.get(`/base/newbieTask/taskList`)
        .then(res => res.data);
}

// 点击不再提醒
export function postIsShowGuide() {
    return request.post(`/base/newbieTask/notShowAgain`)
        .then(res => res.data);
}

// 视频完成任务 提交
export function postFinishViewTask(taskName,isSuccess) {
    return request.post(`/base/newbieTask/finishViewTask/${taskName}/${isSuccess}`)
        .then(res => res.data);
}

// 检测是否已经完成 数据任务
export function postFinishHandleTask() {
    return request.post(`/base/newbieTask/finishHandleTask`)
        .then(res => res.data);
}

// 获取 所有视频链接
export function getAllVideo() {
    return request.get(`/base/newbieTask/allVideo`)
        .then(res => res.data);
}


// 店铺授权验证 参数形式 params: ?a=1&b=2
export function spAuthInfo(params) {
    return request.get(`/base/market/spAuthInfo${params}`)
        .then(res => res);
}


//验证广告授权结果
export function adsBatchAuthCheck(params) {
    return request.post(`/base/market/adsBatchAuthCheck`,params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

//保存广告授权结果
export function adsBatchAuthSave(params) {
    return request.post(`/base/market/adsBatchAuthSave`,params)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}

export function getAdsSupplyCountryCode() {
    return request.get(`/base/market/getAdsSupplyCountryCode`)
        .then((res) => {
            return Promise.resolve(res.data);
        });
}